import { GetOngoingSurveysResponseDTO } from '@/core/dto/psychosocial-report';
import type { GetOngoingSurveysResponse } from '@/types/Psychosocial';

export class GetOngoingSurveysMapper {
	constructor(private readonly data: GetOngoingSurveysResponseDTO) {}

	toDomain(): GetOngoingSurveysResponse {
		return {
			count: this.data.count,
			rows: this.data.rows.map((row) => ({
				id: row.id,
				name: row.name,
				description: row.description,
				organization_id: row.organization_id,
				company_id: row.company_id,
				sector_id: row.sector_id,
				cellule_id: row.cellule_id,
				workstation_id: row.workstation_id,
				tool_id: row.tool_id,
				created_at: row.created_at,
				updated_at: row.updated_at,
				organization_name: row.organization_name,
				company_name: row.company_name,
				sector_name: row.sector_name,
				cellule_name: row.cellule_name,
				workstation_name: row.workstation_name,
				tool_name: row.tool_name,
				survey_link: row.survey_link,
				anonymous: row.anonymous,
				completion_date: row.completion_date,
				total_links: row.total_links,
				total_participations: row.total_participations
			}))
		};
	}
}
